import React from "react";
import RightIcon from "../../assets/svg/DetailsChannel/tick-circle.svg";
import CrossIcon from "../../assets/svg/DetailsChannel/crossIcon.svg";

const ToggleButtonChannel = ({ label, name, value, onChange, error, required }) => (
  // <div className={error ? "form-field hasError" : "form-field"}>
  <>
    <label>
      {label} {required && <span>*</span>}
    </label>
    <button
      type="button"
      className={`custom-toggle ${value === true ? "enabled" : "disabled"}`}
      onClick={() => onChange(name, value === true ? false : true)}
    >
      <span className="toggle-label">{value === true ? "Enabled" : "Disabled"}</span>
      <span className="toggle-circle">
        {value === true ? (
          <img className="check-icon" src={RightIcon} alt="RightIcon" />
        ) : (
          <img className="check-icon" src={CrossIcon} alt="CrossIcon" />
        )}
      </span>
    </button>
      </>
);

export default ToggleButtonChannel;
